/**
 * Mirrors the backend's CLINIC_USER_ROLE_SLUG_CHOICES / CLINIC_USER_STATUS_CHOICES
 * (server/app/models.py). Use these instead of magic strings when checking
 * a ClinicUser's role or status anywhere in the frontend.
 */

export const ClinicUserRoles = Object.freeze({
  Admin: "admin",
  Member: "member",
} as const);

export type ClinicUserRole =
  (typeof ClinicUserRoles)[keyof typeof ClinicUserRoles];

export const ClinicUserStatuses = Object.freeze({
  Active: "active",
  Pending: "pending",
  Rejected: "rejected",
} as const);

export type ClinicUserStatus =
  (typeof ClinicUserStatuses)[keyof typeof ClinicUserStatuses];
